import React from 'react'
import headerImg from '../resources/header.png';


function Header() {
    return (
        <div>

            <img class='w-50' src={headerImg} ></img>

        </div>
    )
}

export default Header
